"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.MailIcon = (0, react_1.forwardRef)(function MailIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.705 5H19.295C20.409 5 20.814 5.116 21.221 5.334C21.628 5.552 21.948 5.872 22.166 6.279C22.384 6.686 22.5 7.09 22.5 8.205V15.795C22.5 16.91 22.384 17.314 22.166 17.721C21.9529 18.1236 21.6236 18.4529 21.221 18.666C20.814 18.884 20.41 19 19.295 19H5.705C4.59 19 4.186 18.884 3.779 18.666C3.37638 18.4529 3.04714 18.1236 2.834 17.721C2.616 17.314 2.5 16.91 2.5 15.795V8.205C2.5 7.09 2.616 6.686 2.834 6.279C3.052 5.872 3.372 5.552 3.779 5.334C4.186 5.116 4.59 5 5.705 5ZM4.5 9.5L4.355 7.763L4.439 7.707L5.498 8.63L11.06 12.549C11.4815 12.846 11.9844 13.0054 12.5 13.0054C13.0156 13.0054 13.5185 12.846 13.94 12.549L19.498 8.634L20.56 7.707L20.645 7.763L20.5 9.5V15.795C20.5 16.222 20.481 16.489 20.451 16.644C20.444 16.6915 20.4273 16.7371 20.402 16.778C20.3755 16.8321 20.3319 16.876 20.278 16.903C20.2371 16.9279 20.1915 16.9443 20.144 16.951C19.989 16.981 19.722 17 19.295 17H5.705C5.278 17 5.011 16.981 4.856 16.951C4.80846 16.944 4.76287 16.9273 4.722 16.902C4.66824 16.8753 4.62469 16.8318 4.598 16.778C4.57272 16.7371 4.55604 16.6915 4.549 16.644C4.519 16.489 4.5 16.222 4.5 15.795V9.5ZM19.05 6.7L16.5 7H8.5L5.95 6.7L5.847 6.769C6.57829 7.05931 7.27276 7.4349 7.916 7.888L12.212 10.914C12.2963 10.9734 12.3969 11.0053 12.5 11.0053C12.6031 11.0053 12.7037 10.9734 12.788 10.914L17.08 7.89C17.7244 7.43627 18.4203 7.06033 19.153 6.77L19.049 6.7H19.05Z", fill: "currentColor" })));
});
